export default {"src":"/_next/static/media/detached-icon-selected.ec771f71.svg","height":85,"width":116,"blurWidth":0,"blurHeight":0};